<template>
    <v-list-item @click.stop.prevent="$evt => sendMessage($evt, item)">
      <v-list-item-icon>
        <v-icon>icon-ayudadigital-whatsapp</v-icon>
      </v-list-item-icon>

      <v-list-item-content v-text="$t('components.share.whatsapp.action')" />
    </v-list-item>
  </template>

<script>

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async sendMessage(evt, item) {
      console.log('send whatsapp message', item);
      evt.preventDefault();
      try {
        const messageId = await this.$store.dispatch(
          'messages/createNotificationMessage',
          {
            icon: 'progress-circular',
            title: this.$t('components.share.whatsapp.create'),
          },
        );
        const { id, userid } = this.$store.getters['session/user'];

        const data = {
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: 'gestnotif/notificaciones/movil/whatsapp',
          },
          url: item.url,
          tlfno: item.tlfno || null,
          type: 'WHATSAPP',
          message: {
            nombrePlantilla: item.tlfno ? 'enlaces_dafa' : 'enlaces_ayudadigital',
            dmsasSuscriptores: [userid],
            claves: [item.formName],
          },
        };
        // NTF_CLIC_2_PUSH_THEM_030
        const result = await this.$api.getClient('gestorNotificacion').shareMobileMessage(data);

        if (result.status === 200) {
          const messageText = `${this.$t('components.share.whatsapp.share')} ${this.phoneNumber()}`;
          this.$store.dispatch('messages/updateMessage', {
            id: messageId,
            type: 'success',
            icon: 'mdi-check-circle',
            title: messageText,
            timeout: this.$getConst('notifications.timeout'),
          });
        } else {
          this.$store.dispatch('messages/updateMessage', {
            id: messageId,
            type: 'error',
            icon: 'mdi-times',
            title: this.$t('components.share.whatsapp.shareFail'),
            timeout: this.$getConst('notifications.timeout'),
          });
        }
        this.$root.$emit('finishShare');
      } catch (ex) {
        console.error('error sending whatsapp message', ex);
        this.$emit('input');
        this.$root.$emit('finishShare');
      }
    },
    phoneNumber() {
      const { mobilePhone } = this.$store.getters['session/user'];
      return `******${mobilePhone.substr(mobilePhone.length - 3, 3)}`;
    },
  },
};
</script>

<style>
.icon-ayudadigital-whatsapp:before {
  color: #827b7b;
}
</style>
